/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LaboratoryResearch } from "./LaboratoryResearch";
import {
  LaboratoryResearchFromJSON,
  LaboratoryResearchFromJSONTyped,
  LaboratoryResearchToJSON,
  LaboratoryResearchToJSONTyped,
} from "./LaboratoryResearch";

/**
 *
 * @export
 * @interface ApiGarLaboratoryresearchesList200Response
 */
export interface ApiGarLaboratoryresearchesList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarLaboratoryresearchesList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarLaboratoryresearchesList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarLaboratoryresearchesList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<LaboratoryResearch>}
   * @memberof ApiGarLaboratoryresearchesList200Response
   */
  results: Array<LaboratoryResearch>;
}

/**
 * Check if a given object implements the ApiGarLaboratoryresearchesList200Response interface.
 */
export function instanceOfApiGarLaboratoryresearchesList200Response(
  value: object
): value is ApiGarLaboratoryresearchesList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarLaboratoryresearchesList200ResponseFromJSON(
  json: any
): ApiGarLaboratoryresearchesList200Response {
  return ApiGarLaboratoryresearchesList200ResponseFromJSONTyped(json, false);
}

export function ApiGarLaboratoryresearchesList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarLaboratoryresearchesList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(LaboratoryResearchFromJSON),
  };
}

export function ApiGarLaboratoryresearchesList200ResponseToJSON(
  json: any
): ApiGarLaboratoryresearchesList200Response {
  return ApiGarLaboratoryresearchesList200ResponseToJSONTyped(json, false);
}

export function ApiGarLaboratoryresearchesList200ResponseToJSONTyped(
  value?: ApiGarLaboratoryresearchesList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(LaboratoryResearchToJSON),
  };
}
